import React from 'react'
import { DateStyles } from 'components/DatePickerStyles/Styles/style'
import CalendarIcon from 'components/icons/CalendarIcon'
import dayjs from 'dayjs'
import Flex from 'components/Flex'
import styled from 'styled-components'

const StyledFlex = styled(Flex)`
  width: ${props => props.width};
  position: relative;
  .ant-picker-dropdown {
    top: ${props => `${props.setStartPosition}!important`};
  }
`
const YourComponent = ({
  id,
  width = '100%',
  name = 'date',
  color = '#010E30',
  placeholder = 'DD/MM/YYYY',
  dateFormat = 'DD/MM/YYYY',
  isEditable = false,
  getPopupContainer,
  onChange,
  value,
  ...props
}) => {
  return (
    <StyledFlex column width={width} id={getPopupContainer ?? 'datePicker'}>
      <DateStyles
        suffixIcon={CalendarIcon}
        id={id}
        width={'100%'}
        color={color}
        opacity="1"
        placeholder={placeholder}
        format={'DD/MM/YYYY'}
        getPopupContainer={() =>
          document.getElementById(getPopupContainer ?? `datePicker`)
        }
        value={value ? dayjs(value, 'DD/MM/YYYY') : null}
        onChange={onChange}
        {...props}
        disabled={isEditable}
      />
    </StyledFlex>
  )
}

export default YourComponent
